// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"509":"0c14d754","1283":"60f744b4"}[chunkId] + ".chunk.css";
};